// extracted by mini-css-extract-plugin
export default {"itemCardWrapper":"slider_itemCardWrapper__VlqNE","productImg":"slider_productImg__pyGQg","productSlider":"slider_productSlider__fNc5Z"};